<div class="p-2">
  <div class="text-center mb-3">
    <mat-icon class="onboarding-icon">link</mat-icon>
    <h4 class="fw-bold mt-2 mb-1">¿Qué es el Slug (URL amigable)?</h4>
    <p class="text-muted mb-0">Así es como los clientes encontrarán tu centro de trabajo en internet</p>
  </div>

  <mat-divider class="mb-3"></mat-divider>

  <div class="mb-3">
    <p>El <strong>slug</strong> es la parte final de la URL pública de tu centro de trabajo. Debe ser corto, sin espacios ni caracteres especiales.</p>
    <div class="example-url mb-2">
      https://booking.handly.es/mi-negocio/<span class="highlight">mi-centro-madrid</span>
    </div>
    <p class="text-muted" style="font-size:13px">La parte destacada en azul es el slug de tu centro de trabajo.</p>
  </div>

  <div class="mb-3">
    <h6 class="fw-bold">Reglas del slug</h6>
    <ul class="text-muted" style="font-size:14px; padding-left:20px">
      <li>Solo letras minúsculas, números y guiones <code>-</code></li>
      <li>Sin espacios ni acentos (se convierten automáticamente)</li>
      <li>Debe ser único para tu cuenta</li>
      <li>Ejemplo: <code>salon-barcelona</code>, <code>clinica-norte</code></li>
    </ul>
  </div>

  <div class="mb-3">
    <h6 class="fw-bold">¿Cómo generarlo?</h6>
    <p class="text-muted" style="font-size:14px">
      Escribe el nombre del centro y pulsa el botón
      <mat-icon style="font-size:16px;vertical-align:middle;color:var(--cf-brand-dark)">autorenew</mat-icon>
      para generar el slug automáticamente, o escríbelo tú mismo.
    </p>
  </div>

  <mat-divider class="mb-3"></mat-divider>

  <div class="d-flex justify-content-end">
    <button mat-flat-button color="primary" (click)="close()">Entendido</button>
  </div>
</div>
